export default "__VITE_PUBLIC_ASSET__80bb3ee5__"